import device from '../helpers/device'
import refs from '../helpers/refs'
import smoothScroll from '../helpers/smoothScroll'
import videoUtil from '../helpers/video'

class CMastheadExplore {
  constructor (el) {
    this.hero = el
    this.$refs = refs(this.hero)

    this.init()
  }

  init () {
    // Different video sources for different screen sizes
    // Convert video data attributes to video sources
    if (this.$refs.video) {
      videoUtil.setVideoSources(this.$refs.video)
    }

    if (this.$refs.scrollDown) {
      this.$refs.scrollDown.addEventListener('click', (e) => {
        smoothScroll(this.hero, false, -100)
      })
    }

    // Set hero to full height on mobile screens
    if (device.isMobile()) {
      this.hero.style.height = window.innerHeight + 'px'
    }
  }
}

// Masthead height won't be set correctly until the page has fully loaded
window.addEventListener('load', () => {
  document
    .querySelectorAll('[data-c-masthead-explore]')
    .forEach(el => new CMastheadExplore(el))
})
